var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.Page())?_c('Navbar'):_vm._e(),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1),(_vm.Page())?_c('Footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }